import React from 'react';
import { Create } from 'react-admin';
import EstadoEstudiosForm from '../EstadoEstudiosForm';

function EstadoEstudiosCreate(props) {
  return (
    <Create {...props}>
      <EstadoEstudiosForm redirect="list" />
    </Create>
  );
}

export default EstadoEstudiosCreate;
